module.exports = __webpack_public_path__ + "img/card-content-4.7c79ae2a.png";